import { ChangeDetectionStrategy, Component, inject, Input, OnChanges } from "@angular/core";
import { TaxesRouteNames } from "@modules/taxes/domain/entities/taxes.model";
import { TaxesNavigationService } from "@modules/taxes/domain/infrastructure/taxes-navigation.service";
import { config } from "@config";
import { TranslationService } from "@core-services/translation.service";
import { BannerCardDismissService } from "@modules/shared/banner-card-module/banner-card-dismiss.service";
import { BANNER_TAXES_STORAGE_DAYS } from "@helpers/constants";
import { TaxesFacade } from "@modules/taxes/domain/+state/taxes.facade";
import { TaxesTrackerFacade } from "@modules/taxes/domain/+state/taxes-tracker-facade.service";
import { TAXES_DO_IT_LATER, TAXES_LEARN_MORE } from "@modules/taxes/domain/entities/taxes-tracking.model";

@Component({
	selector: "taxes-banner",
	templateUrl: "./taxes-banner.component.html",
	styleUrls: ["./taxes-banner.component.scss"],
	providers: [TaxesTrackerFacade],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TaxesBannerComponent implements OnChanges {
	private readonly taxesTrackerFacade = inject(TaxesTrackerFacade);
	private readonly navigationService = inject(TaxesNavigationService);
	private readonly dismissService = inject(BannerCardDismissService);
	private readonly translationService = inject(TranslationService);
	private readonly taxesFacade = inject(TaxesFacade);

	@Input() public isCertificationStep: boolean;
	@Input() public isUpdatingStatus: boolean;

	public title: string = "self_certification_dashboard_widget_title";
	public message: string = "self_certification_dashboard_widget_description";
	public firstButton: string = "yes_i_do";
	public secondButton: string = "no_i_dont";

	public ngOnChanges(): void {
		if (!this.isCertificationStep) {
			this.title = "crypto_declaration_dashboard_widget_title";
			this.message = "crypto_declaration_dashboard_widget_description";
			this.firstButton = "do_it_later";
			this.secondButton = "share_tax_details";
		}
	}

	public onTaxableConfirm(): void {
		this.navigationService.gotoByNavigationUrl(TaxesRouteNames.SelfCertify);
	}

	public onTaxableDeclined(): void {
		this.taxesFacade.updateUserTaxStatus({ status: false, showToast: true });
	}

	public onDoItLater(): void {
		this.taxesTrackerFacade.tracker(TAXES_DO_IT_LATER);
		this.dismissService.dismissForCurrentUser(this.taxesFacade.taxesBannerKey, BANNER_TAXES_STORAGE_DAYS);
	}

	public onShareTaxDetails(): void {
		this.taxesFacade.goToCryptoDeclaration();
	}

	public onLearnMore(): void {
		this.taxesTrackerFacade.tracker(TAXES_LEARN_MORE);
		window.open(this.translationService.getEngDeuHdLink() + config.externalPaths["taxes"]["hdLink"]);
	}
}
